import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";

export function initCookieConsent(onAnalyticsAccepted) {
  CookieConsent.run({
    categories: {
      necessary: {
        enabled: true,
        readOnly: true,
      },
      analytics: {
        enabled: false, // ⛔ PRIVZETO IZKLOPLJENO
      },
    },

    language: {
      default: "sl",
      translations: {
        sl: {
          consentModal: {
            title: "Piškotki 🍪",
            description:
              "Uporabljamo nujne in analitične piškotke. Analitični piškotki se naložijo samo z vašim soglasjem.",
            acceptAllBtn: "Sprejmi analitične",
            acceptNecessaryBtn: "Samo nujni",
            showPreferencesBtn: "Nastavitve",
          },
          preferencesModal: {
            title: "Nastavitve piškotkov",
            acceptAllBtn: "Sprejmi vse",
            acceptNecessaryBtn: "Zavrni analitične",
            savePreferencesBtn: "Shrani izbiro",
            sections: [
              {
                title: "Nujni piškotki",
                description: "Potrebni za delovanje strani.",
                linkedCategory: "necessary",
              },
              {
                title: "Analitični piškotki",
                description:
                  "Pomagajo razumeti uporabo strani (Google Analytics).",
                linkedCategory: "analytics",
              },
            ],
          },
        },
      },
    },

    onFirstConsent: () => {
      if (CookieConsent.acceptedCategory("analytics")) {
        onAnalyticsAccepted();
      }
    },

    onChange: () => {
      if (CookieConsent.acceptedCategory("analytics")) {
        onAnalyticsAccepted();
      }
    },
  });
}